import { absoluteTime, currentPeriodNumber, timeNumericValue } from './game-clock.js';
/**
 * Map penalties for a team
 * @param {Match} match
 * @param {string} team
 * @param {} now
 * @returns
 */
export function mapPenalties(match, team, now) {
    if (!team) {
        return [];
    }
    const key = `${team}Penalties`;
    if (!(key in match)) {
        return [];
    }
    const penalties = match[key];
    // Guard
    if (!penalties) {
        return [];
    }
    const curPeriod = currentPeriodNumber(match);
    const curTime = timeNumericValue(match, now);
    const matchCurrentTimeAbsolute = absoluteTime(match, curPeriod, curTime);
    return penalties.map(penalty => {
        const absoluteStartTime = absoluteTime(match, penalty.gcPeriod, penalty.gcTime);
        const absoluteEndTime = absoluteStartTime + penalty.duration;
        const remaining = 
        // Is current absolute time inside start and end of absolute time of penalty 
        matchCurrentTimeAbsolute >= absoluteStartTime && matchCurrentTimeAbsolute <= absoluteEndTime
            ? absoluteEndTime - matchCurrentTimeAbsolute
            : 0;
        return {
            ...penalty,
            absoluteStartTime,
            absoluteEndTime,
            remaining,
        };
    });
}
/**
 * Active penalties
 *
 * @param {Match} match
 * @param {string} team
 * @param {Timestamp} now
 * @returns
 */
export function activePenalties(match, team, now) {
    return mapPenalties(match, team, now)
        .filter((p) => {
        return p.remaining > 0 && (!('cancelled' in p)
            || !p.cancelled);
    });
}
/**
 * Home penalties
 *
 * @param match
 * @returns
 */
export function homePenalties(match) {
    return match.hPenalties;
}
/**
 * Visitor penalties
 *
 * @param {Match} match
 * @returns
 */
export function visitorPenalties(match) {
    return match.vPenalties;
}
//# sourceMappingURL=match-penalties.js.map